import React, { Component, Fragment } from 'react';
import { Table, Button, Loader, Form, Popup } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import axios from 'axios';

class PollInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            name: '',
            type: '',
            startDate: new Date(),
            endDate: new Date(),
            resultDate: new Date(),
            comment: '',
            selectedOrgUnits: [],
            editStatus: false,
            edit: false,
            infoLoader: true,
            optLock: 0,
            originalPoll: null,
            loader: false
        };
    }

    componentDidMount() {
        const poll = JSON.parse(localStorage.getItem('poll'));
        if (poll && poll.pollId) {
            this.getPollById(poll.pollId);
        }
    }

    getPollById(id) {
        axios.post(`/questionnaire/${id}/`)
            .then(res => {
                const poll = res.data;
                this.setState({
                    id: poll.id,
                    name: poll.name,
                    type: (poll.questionnaireType && poll.questionnaireType.id) || '',
                    startDate: new Date(poll.activationDate),
                    endDate: new Date(poll.endDate),
                    resultDate: new Date(poll.statisticsActivationDate),
                    comment: poll.comment,
                    selectedOrgUnits: poll.organizationalUnits || [],
                    infoLoader: false,
                    editStatus: poll.questionnaireStatus._key === "in progress",
                    optLock: poll.optLock,
                    originalPoll: poll
                });
                localStorage.setItem('fullPoll', JSON.stringify(res.data));
            })
            .catch(err => {
                console.log('Failed to fetch poll data.', err);
                this.setState({ infoLoader: false });
            });
    }

    handleChange(field, value) {
        this.setState({ [field]: value });
    }

    editPoll() {
        const { id, name, type, startDate, endDate, resultDate, comment, selectedOrgUnits, optLock } = this.state;

        if (!name || !type || !startDate || !endDate || !resultDate) {
            toast('Obavezna polja');
            return;
        }

        if (startDate >= endDate) {
            toast('Datum objave mora biti prije datuma isteka.');
            return;
        }

        if (resultDate < endDate) {
            toast('Datum objave rezultata mora biti nakon datuma isteka.');
            return;
        }

        this.setState({ loader: true });

        const obj = {
            id: id,
            name: name,
            comment: comment || null,
            activationDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            statisticsActivationDate: resultDate.toISOString(),
            optLock: optLock,
        };

        axios.put('/questionnaire/edit/', {...obj})
            .then(res => {
                this.setState({ loader: false, edit: false }, () => {
                    this.getPollById(id);;
                    toast('Anketa je uspješno ažurirana.');
                });
            })
            .catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške prilikom ažuriranja ankete.');
                console.log(err);
            });
    }

    handleCancel = () => {
        this.setState({ edit: false, infoLoader: true }, () => this.getPollById(this.state.id));
    }

    renderField(label, fieldName, isDate = false) {
        const { edit } = this.state;
        const value = this.state[fieldName];

        return (
            <Table.Row key={fieldName}>
                <Table.Cell style={{ fontWeight: 'bold', textAlign: 'right', width: '50%' }}>
                    {label}
                </Table.Cell>
                <Table.Cell style={{ width: '50%' }}>
                    {edit ? (
                        isDate ? (
                            <DateTimePicker
                                format="D. M. YYYY."
                                time={false}
                                value={value}
                                onChange={(date) => this.handleChange(fieldName, date)}
                                style={{ width: '100%' }}
                            />
                        ) : (
                            <Form.Input
                                fluid
                                value={value || ''}
                                onChange={(e, { value }) => this.handleChange(fieldName, value)}
                            />
                        )
                    ) : (
                        isDate ? moment(value).format('D. M. YYYY.') : value || '/'
                    )}
                </Table.Cell>
            </Table.Row>
        );
    }

    render() {
        const { edit, infoLoader, editStatus, loader } = this.state;

        return (
            <div>
                <ToastContainer />

                {editStatus && (
                    <div style={{ overflow: 'hidden', marginBottom: '10px' }}>
                        {!edit ? (
                            <Popup
                                content="Izmijeni"
                                position="top center"
                                trigger={
                                    <Button
                                        floated="right"
                                        basic
                                        color="blue"
                                        icon="pencil"
                                        circular
                                        size="mini"
                                        onClick={() => this.setState({ edit: true })}
                                    />
                                }
                            />
                        ) : (
                            <Fragment>
                                <Popup
                                    content="Odustani"
                                    position="top center"
                                    trigger={<Button floated="right" basic color="red" icon="cancel" circular size="mini" onClick={this.handleCancel} />}
                                />
                                <Popup
                                    content="Sačuvaj"
                                    position="top center"
                                    trigger={<Button floated="right" basic color="green" icon="check" circular size="mini" onClick={() => this.editPoll()} />}
                                />
                            </Fragment>
                        )}
                    </div>
                )}

                {infoLoader || loader ? (
                    <Loader active inline="centered" />
                ) : (
                    <Table celled>
                        <Table.Body>
                            {this.renderField("Naziv ankete", "name")}
                            {this.renderField("Datum objave", "startDate", true)}
                            {this.renderField("Datum isteka", "endDate", true)}
                            {this.renderField("Datum objave rezultata", "resultDate", true)}
                            {this.renderField("Napomena", "comment")}
                        </Table.Body>
                    </Table>
                )}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default PollInfo;



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollPreviewTabs/PollInfo/PollInfo.js